import {NodeTypes} from "@xyflow/react";
import WorkflowNode from "./WorkflowNode";
import BranchNode from "./BranchNode";
import JumpNode from "./JumpNode";
import {WorkflowNodesData} from "./NodesData";
import {AssistantType, WorkflowNodeTypes} from "@/types/node";

export const createNodeTypes = (
  showContext: boolean,
  assistantType: AssistantType,
): NodeTypes => {
  return Object.keys(WorkflowNodesData).reduce((acc, key) => {
    switch (key) {
      case WorkflowNodeTypes.BRANCH:
        acc[key] = props => <BranchNode {...props} showContext={showContext} />;
        break;
      case WorkflowNodeTypes.JUMP:
        acc[key] = props => <JumpNode {...props} showContext={showContext} />;
        break;
      default:
        acc[key] = props => (
          <WorkflowNode
            {...props}
            showContext={showContext}
            assistantType={assistantType}
          />
        );
    }
    return acc;
  }, {} as NodeTypes);
};
